import { render, staticRenderFns } from "./DesignInput.vue?vue&type=template&id=ade9a3b8&scoped=true&"
import script from "./DesignInput.vue?vue&type=script&lang=js&"
export * from "./DesignInput.vue?vue&type=script&lang=js&"
import style0 from "./DesignInput.vue?vue&type=style&index=0&id=ade9a3b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ade9a3b8",
  null
  
)

export default component.exports